// extracted by mini-css-extract-plugin
module.exports = {"c-content-page":"ContentPage_c-content-page__oL7Sm"};